<template>
    <div class="library-qa-status-filter">
        <CollapsibleWidget>
            <template #name>Production Status</template>

            <RadioGroup v-model="creativeLibraryFiltersStore.qaStatus">
                <Radio v-for="filter in BannerQaStatusFilter" :key="filter" :label="filter">
                    <div
                        v-if="filter !== BannerQaStatusFilter.All"
                        class="library-qa-status-filter__status-dot-wrapper"
                    >
                        <QaStatusDot :status="filter" />
                    </div>
                    {{ BannerQaStatusFilterLabel[filter] }}
                </Radio>
            </RadioGroup>
        </CollapsibleWidget>
    </div>
</template>

<script lang="ts" setup>
import CollapsibleWidget from "@/components/Campaign/widgets/CollapsibleWidget.vue";
import QaStatusDot from "@/components/Qa/QaStatusDot.vue";
import { BannerQaStatusFilter, BannerQaStatusFilterLabel } from "@/enums/filters";
import { useCreativeLibraryFiltersStore } from "@/store/pinia/creativeLibraryFilters";

const creativeLibraryFiltersStore = useCreativeLibraryFiltersStore();
</script>

<style lang="scss">
@use "@style/variables" as *;

.library-qa-status-filter {
    .ivu-radio {
        margin: 0;
    }

    .ivu-radio-group {
        display: block;
    }

    .ivu-radio-wrapper {
        margin: 0;
        padding: 0 0 0 50px;
        display: block;
    }
}

.library-qa-status-filter__status-dot-wrapper {
    display: inline-block;
    padding: 0 0 0 $spacing-smaller;
}
</style>
